import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

// Fees schema
export const FeesInitialValues = {
  typePayment: 1,
  farm: 1,
  dni: 0,
  nroDni: "",
  amount_to_pay: 0,
  comment_code: "",
  iban: "",
  name: "",
  email: "",
  country: 0,
  address: "",
}

export const FeesValidationSchema = (context) => {
  return Yup.object({
    typePayment: Yup.string().required(FIELD_REQUIRED_MESSAGE),
    farm: Yup.number().required(FIELD_REQUIRED_MESSAGE),
    amount_to_pay: Yup.number()
      .required(FIELD_REQUIRED_MESSAGE)
      .max(context.maxAmount, `El valor no puede ser mayor a ${context.maxAmount}`),
  });
};

export const AssignFeeUserInitialValues = {
  typePayment: 1,
  farm: 1,
  dni: 0,
  nroDni: "",
  amount_to_pay: 0,
  comment_code: "",
  iban: "",
  name: "",
  email: "",
  country: "",
  address: "",
  remaining: false,
  reasons_payment: 0,
  registration_payment: 0,
  start_date: "",
  cash_subscription_type: 1,
  payment_complete: 0,
  payment_parcial: 0,
}
